<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isSaving || checkingProductCombination || isDeleting">
  <form id="spec-line-edit-form" [formGroup]="specificationLineForm">
    <div class="w-full flex flex-row items-center justify-between">
      <div class="w-full section-header justify-self-start">
        @if ((!addLineMode && !editMode) || specificationLine.defaultSpec) {
        <p class="p-0 mt-3" id="specification-line-name">
          {{ lineName }}
        </p>
        } @if (editMode && !specificationLine.defaultSpec) {
        <mat-form-field class="mr-5 edit-component" subscriptSizing="dynamic" id="specline-label-field">
          <mat-label>{{ translationService.translate('nameText') }}</mat-label>
          <input matInput type="text" placeholder="" [formControlName]="'label'" (blur)="checkIfSpecLineNameIsValid()" />
          @if (specificationLineForm.get('label').hasError('nameIsInvalid')) {
          <mat-error>{{ translationService.translate('nameExistsText') }}</mat-error>
          } @if (specificationLineForm.get('label').hasError('required')) {
          <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
          }
        </mat-form-field>
        }
      </div>
      <div class="view-edit-spec-button-container">
        @if (!editMode && hasEditPermission) {
        <button
          id="edit-link"
          type="button"
          mat-flat-button
          color="primary"
          class="mic-btn-icon-left"
          style="margin-right: 14px; margin-top: 2px"
          (click)="enableEdit()"
        >
          <mat-icon>edit</mat-icon>
          {{ translationService.translate('editLinkText') }}
        </button>
        } @if (editMode) {
        <button
          id="cancel-link"
          type="button"
          mat-flat-button
          color="primary"
          class="mic-btn-icon-left"
          style="margin-right: 14px; margin-top: 2px"
          (click)="cancel()"
        >
          <mat-icon>cancel</mat-icon>
          {{ translationService.translate('cancelLinkText') }}
        </button>
        } @if (editMode) {
        <button
          id="save-link"
          type="button"
          mat-flat-button
          color="primary"
          class="mic-btn-icon-left"
          style="margin-right: 14px; margin-top: 2px"
          [disabled]="isSaving || checkingProductCombination"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
        }
      </div>
      @if (hasEditPermission && !isDefault && !editMode) {
      <div class="flex ml-1">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
        <mat-menu id="spec-line-option-menu" #menu="matMenu">
          <button id="delete-spec-button" type="button" mat-menu-item (click)="deleteSpecLine()">
            <mat-icon class="delete-spec-icon">delete</mat-icon>{{ translationService.translate('deleteSpecLineText') }}
          </button>
        </mat-menu>
      </div>
      }
    </div>

    @if (specificationLine.exceedMichelinSpec) {
    <div class="flex flex-row m-1">
      <mat-chip-set aria-label="Tag">
        <mat-chip disableRipple class="mic-chip" color="accent">{{ translationService.translate('exceedPillText') }}</mat-chip>
      </mat-chip-set>
    </div>
    }

    <div class="flex flex-row place-items-center justify-between">
      <div class="section-header justify-self-start">
        <p id="spec-type-toggle-button-label" class="specification-type-label mb-1">
          {{ translationService.translate('specificationTypeText') }}
        </p>
        <mat-button-toggle-group
          id="spec-type-toggle-button"
          name="fontStyle"
          class="mic-button-toggle-group mt-0 mb-2"
          aria-label="CAMSpecType"
          (change)="onToggleButtonChange($event)"
        >
          <mat-button-toggle
            id="spec-type-toggle-button-rr"
            value="10"
            class="mic-button-toggle mic-button-toggle-disabled"
            [disabled]="!addLineMode"
            [checked]="specificationLine.type === 10"
            >{{ translationService.translate('repairAndRetreadText') }}</mat-button-toggle
          >
          <mat-button-toggle
            id="spec-type-toggle-button-ro"
            value="20"
            class="mic-button-toggle mic-button-toggle-disabled"
            [disabled]="!addLineMode"
            [checked]="specificationLine.type === 20"
            >{{ translationService.translate('repairOnlyText') }}</mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>
    </div>

    <app-spec-line-definition
      id="spec-line-definition-component"
      [specLine]="specificationLine"
      [editMode]="isDefault ? false : editMode"
    ></app-spec-line-definition>

    <app-ntr-age id="ntr-and-age-component" [ntr]="specificationLine.ntr" [age]="specificationLine.age" [editMode]="editMode"></app-ntr-age>

    @for (limit of specificationLine.limits; track limit; let i = $index) {
    <div>
      <app-repair-limit id="repair-limit-{{ i }}" [limit]="limit" [index]="i" [specLine]="specificationLine" [editMode]="editMode" />
    </div>
    } @if (specification && !addLineMode) {
    <div class="audit-container">
      <p id="audit-modified">Last updated: {{ modifiedDate }} by {{ specification.modifiedBy }}</p>
      <p id="audit-created">Created: {{ createdDate }} by {{ specification.createdBy }}</p>
    </div>
    } @if (editMode && !secondRepairLimitAdded && specificationLine.limits.length < 2) {
    <span class="add-repair-limit" id="add-repair-limit-link" (click)="addRepairLimit()">{{
      translationService.translate('addRepairLimitText')
    }}</span>
    }
  </form>
</mic-spinner-overlay>

<mic-modal class="modalC" #saveConfirmationModal (result)="onSaveConfirmationModalClosed($event)"></mic-modal>
<ng-template #saveConfirmation
  ><b>{{ exceedMichelinSpec ? this.translationService.translate('exceedPopupBoldText') : '' }}</b
  >{{
    exceedMichelinSpec ? this.translationService.translate('exceedPopupText') : this.translationService.translate('savePopupText')
  }}</ng-template
>

<mic-modal class="modalC" #duplicateConfirmationModel></mic-modal>
<ng-template #duplicateConfirmation>
  {{ this.translationService.translate('duplicateCamSpecLineContentText') }}
</ng-template>

<mic-modal class="modalC" #deleteSpecLineModal (result)="onDeleteSpecLineModalClosed($event)"></mic-modal>
<ng-template #deleteSpecLineContent>
  {{ translationService.translate('deleteCamSpecModalContentLine1Text') }}
  {{ translationService.translate('specLineText') }}?
  {{ translationService.translate('deleteCamSpecModalContentLine2Text') }}
</ng-template>
